export default "__VITE_ASSET__z8V$$g_N__"